export default __webpack_public_path__ + "media/images/react_icons/booking-bf683186abd962a3d5ea55dc6ab1088c.svg";